import { Injectable } from '@angular/core';
import { IDatabase } from './IDatabase';
import { MongoCast } from './mongo/lottoloca-mongo-db';
import { WebApiConnectionService } from "./mongo/WebApiConnectionService";

import { RavenCast } from './raven/lottoloca-raven-db';

@Injectable()
export class DatabaseManagerService {

   
    
    
    private mongoDb:IDatabase;
    
    //private ravenDb:IDatabase =  new RavenCast.LottolocaRavenDb(this.httpRaven);
 constructor(private httpMongo:WebApiConnectionService)
    {
         this.mongoDb =  new MongoCast.LottolocaMongoDb(this.httpMongo);
    }

    public get(key:string):IDatabase
    {

        if(key == "MongoDb")
        {
        return this.mongoDb;
        }
        else{
          throw new Error("Database not found: " + key);
        }
    }
}

